import styled from "styled-components";

export const StyledResizableContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const StyledJamImage = styled.image`
  animation-name: set-opacity;
  animation-duration: 1s;
  animation-fill-mode: forwards;

  @keyframes set-opacity {
    0% {
      opacity: 0.75;
      filter: blur(2px);
    }
    100% {
      opacity: 1;
      filter: blur(0);
    }
  }
`;
